export default __webpack_public_path__ + "static/media/icon-facebook-filled.ff80bbb2.svg";